import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

const useSwitchExchangeToRefund = ({ returnId, fetchData }) => {
  const [showSwitchExchangeToRefundModal, setShowSwitchExchangeToRefundModal] = useState(false)
  const { fetchData: fetchSwitchExchangeToRefund, loading } = useFetch(returnsServices.switchExchangeToRefund, {
    doInitialRequest: false,
  })

  const switchExchangeToRefund = async () => {
    await fetchSwitchExchangeToRefund({ returnId })
    setShowSwitchExchangeToRefundModal(false)
    fetchData()
  }

  const closeSwitchExchangeToRefundModal = () => {
    setShowSwitchExchangeToRefundModal(false)
  }

  const openSwitchExchangeToRefundModal = () => {
    setShowSwitchExchangeToRefundModal(true)
  }

  return {
    showSwitchExchangeToRefundModal,
    setShowSwitchExchangeToRefundModal,
    switchExchangeToRefund,
    closeSwitchExchangeToRefundModal,
    openSwitchExchangeToRefundModal,
    switchingExchangeToRefund: loading,
  }
}

export default useSwitchExchangeToRefund
